import BaseComponent from "../../../shared/baseComponent/BaseComponent";
import { useApiClient } from "../../../shared/customHooks";
import { providerForm } from "../../../shared/formObjects/provider/providerForm";
import { useGlobalContext } from "../../../shared/GlobalContext";
import { useProviderContext } from "../context/providerContext";

function ProviderDetailsComponent({ disabled, data }: any) {
  const api = useApiClient("ProviderDetails");
  const { id } = useProviderContext();
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  return (
    <>
      {" "}
      <BaseComponent
        formBody={providerForm}
        headerLabel="KIS Provider Details"
        showEdit={isManager && disabled ? true : false}
        editPath="providerDetails"
        apiClient={api}
        disabled={disabled}
        data={data}
        id={id}
      />
    </>
  );
}

export default ProviderDetailsComponent;
